export enum StepViewerEvents {
  InitiateNextViewRender = 'InitiateNextViewRender',
  ProcessCurrentView = 'ProcessCurrentView',
  RenderNextView = 'RenderNextView',
  RenderPreviousView = 'RenderPreviousView',
  DisableProceeding = 'DisableProceeding',
  EnableProceeding = 'EnableProceeding',
  SetNextLoading = 'SetNextLoading',
  UnsetNextLoading = 'UnsetNextLoading',
  DisableControls = 'DisableControls',
  EnableControls = 'EnableControls',
  HideControls = 'HideControls',
  ShowControls = 'ShowControls',
  FinishSteps = 'FinishSteps',
  NextAction = 'NextAction',
  PreviousAction = 'PreviousAction',
  GoToStep = 'GoToStep',
  RenderStep = 'RenderStep',
  StepperStepFinishedScrolling = 'StepperStepFinishedScrolling'
}
